import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  syncToHiddenField() {
    const hiddenField = document.getElementById("projectField")
    if (hiddenField && this.hasSelectTarget) {
      hiddenField.value = this.selectTarget.value
    }
  }
}
